import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/method")({ component: () => <Outlet /> });
